/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BatchGetCompletionFeedbackRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  batchGetFeedbackRequest: components.BatchGetFeedbackRequest;
};

/** @internal */
export const BatchGetCompletionFeedbackRequest$inboundSchema: z.ZodType<
  BatchGetCompletionFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  BatchGetFeedbackRequest: components.BatchGetFeedbackRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "BatchGetFeedbackRequest": "batchGetFeedbackRequest",
  });
});
/** @internal */
export type BatchGetCompletionFeedbackRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  BatchGetFeedbackRequest: components.BatchGetFeedbackRequest$Outbound;
};

/** @internal */
export const BatchGetCompletionFeedbackRequest$outboundSchema: z.ZodType<
  BatchGetCompletionFeedbackRequest$Outbound,
  z.ZodTypeDef,
  BatchGetCompletionFeedbackRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  batchGetFeedbackRequest: components.BatchGetFeedbackRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    batchGetFeedbackRequest: "BatchGetFeedbackRequest",
  });
});

export function batchGetCompletionFeedbackRequestToJSON(
  batchGetCompletionFeedbackRequest: BatchGetCompletionFeedbackRequest,
): string {
  return JSON.stringify(
    BatchGetCompletionFeedbackRequest$outboundSchema.parse(
      batchGetCompletionFeedbackRequest,
    ),
  );
}
export function batchGetCompletionFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<BatchGetCompletionFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BatchGetCompletionFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BatchGetCompletionFeedbackRequest' from JSON`,
  );
}
